import APIRequest from "./APIRequest";

// Admin Dashboard Services
export const getAdminDashboardData = (params) => {
  return APIRequest.get(`admin/dashboard`, params);
};

export const getAdminAnalytics = (params) => {
  return APIRequest.get(`admin/analytics`, params);
};

export const getSystemHealth = (params) => {
  return APIRequest.get(`admin/system/health`, params);
};

export const getRecentActivities = (params) => {
  return APIRequest.get(`admin/activities`, params);
};

export const getSystemMetrics = (params) => {
  return APIRequest.get(`admin/metrics`, params);
};